import { render, staticRenderFns } from "@/modules/Insured/templates/insureds-list.html?vue&type=template&id=5db19ffa&scoped=true&"
import script from "@/modules/Insured/scripts/insureds-list.ts?vue&type=script&lang=js&"
export * from "@/modules/Insured/scripts/insureds-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Insured/styles/insureds-list.scss?vue&type=style&index=0&id=5db19ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db19ffa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
